import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES, createI18n, type Language } from '@mcgames/i18n';
import type { i18n as I18n } from 'i18next';

const LANGUAGE_KEY = 'mcgames.lang';

function isLanguage(value: string | null): value is Language {
  return SUPPORTED_LANGUAGES.some((language) => language === value);
}

export function readStoredLanguage(): Language {
  try {
    const stored = localStorage.getItem(LANGUAGE_KEY);
    if (isLanguage(stored)) return stored;
  } catch {
    // Storage blocked: use the default.
  }
  return DEFAULT_LANGUAGE;
}

export function createAppI18n(): I18n {
  const instance = createI18n(readStoredLanguage());
  document.documentElement.lang = instance.language;
  return instance;
}

/** Switches the UI language and remembers the choice. */
export async function setLanguage(instance: I18n, language: Language): Promise<void> {
  try {
    localStorage.setItem(LANGUAGE_KEY, language);
  } catch {
    // The choice just does not survive a reload.
  }
  document.documentElement.lang = language;
  await instance.changeLanguage(language);
}
